const ATLANTIC_MACKEREL_SPECIES_ID = "scomber_scombrus";

const M0 = Object.freeze({
  activityStatus: "not_modelled",
  opportunityMode: "availability_only",
  availabilityScope: "regional_presence",
  reachabilityStatus: "reachability_not_modelled",
  confidenceScope: "regional_assessment",
  regionalAvailabilityField: "availability",
  legacyOpportunityField: "fishingOpportunity",
  accessibleAvailability: null,
  combinedOpportunity: null,
});

export const normalizeMackerelCapabilities = (speciesId, value) => {
  if (speciesId !== ATLANTIC_MACKEREL_SPECIES_ID) return null;
  // Old cached responses lack capabilities; their Mackerel V1 semantics are known.
  if (value == null || (value.activity_status === "not_modelled" &&
      value.opportunity_mode === "availability_only" &&
      value.availability_scope === "regional_presence" &&
      value.reachability_status === "reachability_not_modelled" &&
      value.accessible_availability === null && value.combined_opportunity === null)) return M0;
  return null;
};

export const isMackerelRegional = (context) =>
  context?.capabilities?.availabilityScope === "regional_presence" &&
  context?.capabilities?.activityStatus === "not_modelled";

// Translate shared display labels consistently, without changing shared ranking,
// stored values, chart interaction or any other species' vocabulary.
export const MACKEREL_SCOPE_KEYS = {
  fishing_today_intelligence_opportunity: "mackerel_regional_availability",
  fishing_today_intelligence_availability: "mackerel_regional_availability",
  fishing_today_intelligence_opportunity_hint: "mackerel_scope_hint",
  fishing_today_intelligence_explanation_opportunity: "mackerel_scope_hint",
  fishing_today_intelligence_confidence: "mackerel_regional_confidence",
  fishing_today_intelligence_forecast_confidence: "mackerel_regional_confidence",
  fishing_today_intelligence_scope_confidence: "mackerel_regional_confidence",
  fishing_today_intelligence_hourly_outlook: "mackerel_hourly_title",
  fishing_today_intelligence_hourly_outlook_description: "mackerel_hourly_description",
  fishing_today_intelligence_timeline_chart_aria: "mackerel_chart_aria",
  fishing_today_intelligence_highest_opportunity_hours: "mackerel_selected_hours",
  fishing_today_intelligence_strongest_hours: "mackerel_selected_hours",
  fishing_today_intelligence_strongest_hour: "mackerel_selected_hours",
  fishing_today_intelligence_strongest_period: "mackerel_selected_period",
  fishing_today_intelligence_best_modeled_period: "mackerel_best_period",
  fishing_today_intelligence_peak_opportunity: "mackerel_peak",
  fishing_today_intelligence_no_opportunity_hours: "mackerel_no_hours",
  fishing_today_intelligence_no_standout_period: "mackerel_no_standout",
  fishing_today_intelligence_similar_opportunity_period: "mackerel_similar_periods",
  fishing_today_intelligence_period_choice_note: "mackerel_period_note",
  fishing_today_intelligence_safety_disclosure: "mackerel_safety_disclosure",
  sea_bass_period_average: "mackerel_period_average",
  sea_bass_period_note: "mackerel_period_note",
  sea_bass_modeled_period: "mackerel_selected_period",
  sea_bass_similar_periods: "mackerel_similar_periods",
};

export const withMackerelScope = (t, context) => isMackerelRegional(context)
  ? (key, options) => t(MACKEREL_SCOPE_KEYS[key] || key, options)
  : t;

export const hasDistinctLegacyIndex = (point) =>
  Number.isFinite(point?.fishingOpportunity?.score) &&
  point.fishingOpportunity.score !== point?.availability?.score;

export const regionalConfidence = (point) =>
  point?.eligibility?.biological !== "blocked" &&
  Number.isFinite(point?.availability?.score) ? point.confidence : null;
